module.exports = __webpack_public_path__ + "img/minimize_chat_2.d7c38c68.svg";